import { Injectable } from '@angular/core';

import { Subject } from 'rxjs/Subject';

type Severities = 'success' | 'info' | 'warn' | 'error';

@Injectable()
export class NotificationsService {
  notificationChange: Subject<Object> = new Subject<Object>();

  messageOnLogonExpired = 'Logon session expired or is not valid';
  
  notify(severity: Severities, summary: string, detail: string) {
    if (detail === this.messageOnLogonExpired || summary === this.messageOnLogonExpired) {
      severity = 'warn';
    } else {
      severity = 'error';
    }
    this.notificationChange.next({ severity, summary, detail });
  }

  notifyError(detail: string, summary = 'Error') {
    let severity: Severities;
    if (detail === this.messageOnLogonExpired || summary === this.messageOnLogonExpired) {
      severity = 'warn';
    } else {
      severity = 'error';
    }
    console.log(`Error: ${detail}`);
    this.notificationChange.next({ severity, summary, detail });
  }

  notifySuccess(detail: string, summary: string = '') {
    const severity: Severities = 'success';
    console.log(`Success: ${detail}`);
    this.notificationChange.next({ severity, summary, detail });
  }

  notifyInfo(detail: string, summary: string = '') {
    const severity: Severities = 'info';
    console.log(`Info: ${detail}`);
    this.notificationChange.next({ severity, summary, detail });
  }

  notifyWarn(detail: string, summary: string = '') {
    const severity: Severities = 'warn';
    console.log(`Warning: ${detail}`);
    this.notificationChange.next({ severity, summary, detail });
  }
}
